import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import StacksSection from '../components/StacksSection';
import ProjectsSection from '../components/ProjectsSection';
import CertificatesSection from '../components/CertificatesSection';
import ExperienceSection from '../components/ExperienceSection';
import ContactBanner from '../components/ContactBanner';

export default function Home() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <ExperienceSection />
      <ProjectsSection />
      <StacksSection />
      <CertificatesSection />
      <ServicesSection />
      <ContactBanner />
    </>
  );
}
